<template>
  <div class="main-container">
    <div class="title-container">
      <div class="text-primary-language">
        {{ $t('i18n.thankYouForFeedback') }}
      </div>
      <div class="text-secondary-language">
        <span v-if="bilingual">
          {{ $t('i18n.thankYouForFeedback', 'en') }}
        </span>
      </div>
    </div>
    <div class="subtitle-container">
      <div class="text-primary-language">
        {{ $t('i18n.responsesSubmittedWithSuccess') }}
      </div>
      <div class="text-secondary-language">
        <span v-if="bilingual">
          {{ $t('i18n.responsesSubmittedWithSuccess', 'en') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ThankYouForParticipating',
  props: {
    bilingual: {
      type: Boolean,
      required: false,
      default: false
    }
  }
})
</script>

<style lang="scss" scoped>
@import "@/styles/colors.scss";

.main-container {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr auto;

  padding: 2em 5% 2em 5%;

  height: 100%;
  color: $gorate-secondary;

  .title-container {
    grid-row: 1;

    padding-bottom: 1em;

    .text-primary-language {
      font-size: clamp(1.5em, 1vw + 1rem, 2em);
      font-weight: bold;
      padding-bottom: 0.2em;
    }

    .text-secondary-language {
      font-size: clamp(1em, 0.5vw + 1rem, 1.5em);
      padding-bottom: 0.2em;
    }
  }

  .subtitle-container {
    grid-row: 2;

    .text-primary-language {
      font-size: clamp(1em, 0.5vw + 1rem, 1.5em);
      padding-bottom: 0.5em;
    }

    .text-secondary-language {
      font-size: clamp(0.8em, 0.5vw + 1rem, 1.2em);
      padding-bottom: 0.5em;
    }
  }
}
</style>
